var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['flex', 'absolute', '-bottom-px', 'ltr:left-0', 'rtl:right-0'],attrs:{"dir":_vm.dir}},[_c('div',{class:[
      {
        flex: true,
        'items-center': true,
        [_vm.lightMainBgColorClass]: _vm.isBrowserDecidingDarkMode || _vm.isForcedLight,
        'text-dark-text-100': _vm.isBrowserDecidingDarkMode || _vm.isForcedLight,
        [_vm.darkBrowserMainBgColorClass]: _vm.isBrowserDecidingDarkMode,
        'dark:text-light-text-100': _vm.isBrowserDecidingDarkMode,
        [_vm.darkMainBgColorClass]: _vm.isForcedDark,
        'text-light-text-100': _vm.isForcedDark,
        'text-body-extra-small': true,
        'h-6': true,
        'ltr:pl-3': _vm.usageContext === 'postModal',
        'ltr:pl-2': _vm.usageContext !== 'postModal',
        'rtl:pr-3': _vm.usageContext === 'postModal',
        'rtl:pr-2': _vm.usageContext !== 'postModal',
        'flex-shrink': true,
        'min-w-0': true,
        'z-10': true,
      },
    ]},[_vm._t("default")],2),_vm._v(" "),_c('svg',{staticClass:"transform scale-100 rtl:scale-x-[-1] flex-shrink-0 -translate-x-px rtl:translate-x-px z-0",attrs:{"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{class:[
        'fill-current',
        { [_vm.lightSlopeColorClass]: _vm.isBrowserDecidingDarkMode || _vm.isForcedLight },
        { [_vm.darkBrowserSlopeColorClass]: _vm.isBrowserDecidingDarkMode },
        { [_vm.darkSlopeColorClass]: _vm.isForcedDark },
      ],attrs:{"d":"M13 12C9.5 6.67572e-06 1 5.44637e-06 1 5.44637e-06L0 -0.00012207V25H25V24C25 24 16.5 24 13 12Z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }